import { GLItemDTO, GLItemKind, GLItemStatuses } from '../../../DTO/GLItemDTO'

export enum LogChatMsgStatus {
  idle,
  saving,
  deleted,
}

export type PersonTagConfig = {
  kind: 'FUNKTIONHOMOGEN' | 'ABTEILUNGHOMOGEN' | 'marketingRole' | 'groupInfo' | 'sales_origin'
  mode: 'single' | 'list'
}

export const PERSON_TAG_CONFIGS: PersonTagConfig[] = [
  { kind: 'FUNKTIONHOMOGEN', mode: 'single' },
  { kind: 'ABTEILUNGHOMOGEN', mode: 'single' },
  { kind: 'marketingRole', mode: 'list' },
  { kind: 'groupInfo', mode: 'list' },
  { kind: 'sales_origin', mode: 'single' },
]

export function hasStatusOptions(glitem: GLItemDTO): boolean {
  return glitem.kind !== undefined && GLItemStatuses[glitem.kind].length > 0
}

export function isMarketing(glitem: GLItemDTO): boolean {
  return glitem.kind === GLItemKind.marketing
}

export function isRootItem(glitem: GLItemDTO): boolean {
  return !glitem.parentId || glitem.parentId === -1
}

export function cloneGlItem(glitem: GLItemDTO): GLItemDTO {
  return Object.assign(Object.create(Object.getPrototypeOf(glitem)), glitem)
}

export function formatMetaEuro(value?: number | null): string {
  if (value === undefined || value === null || Number.isNaN(value)) {
    return '–'
  }
  return `${value}`
}

export function formatMetaPercent(value?: number | null): string {
  if (value === undefined || value === null || Number.isNaN(value)) {
    return '–'
  }
  return `${value}%`
}
